import { getThemeForKey, makeStyles } from "@mcleod/core";

export const CheckboxStyles = makeStyles("chk", () => {
  return {
    checkBase: { display: "flex", alignItems: "center", userSelect: "none" },
    image: {
      display: "flex", alignItems: "center", outline: "none",
      "&:focus-within": getThemeForKey("checkbox.styleHoverCircle"),
      "&:hover": getThemeForKey("checkbox.styleHoverCircle")
    },
    imageDisabled: {
      display: "flex", alignItems: "center", outline: "none",
    },
  };
});